function init( node ) {
	// Validate Swiper availability
	const { Swiper } = window;
	if ( ! Swiper ) {
		console.warn( 'Swiper not available. Make sure swiper is enqueued.' );
		return;
	}

	const swiper = node.querySelector( '.post-slider__swiper' );
	const nextEl = node.querySelector( '.swiper-button-next' );
	const prevEl = node.querySelector( '.swiper-button-prev' );

	const modules = [
		Swiper.Navigation,
		Swiper.A11y,
		Swiper.EffectFade,
	].filter( Boolean );

	const inst = new Swiper( swiper, {
		...( modules.length > 0 && { modules } ),
		a11y: true,
		effect: 'fade',
		fadeEffect: {
			crossFade: true,
		},
		slidesPerView: 1,
		spaceBetween: 0,
		grabCursor: false,
		speed: 300,
		navigation: {
			nextEl,
			prevEl,
		},
	} );

	return inst;
}

document.querySelectorAll( '.post-slider' ).forEach( init );
